import React from 'react';
import {Card, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card';
import Chip from 'material-ui/Chip';

const styles = {
  card:{
    margin:8,
    paddingBottom:0,
  },
  cardheader:{
    padding:8,
    paddingBottom:0,
  },
  imgStyle:{
    //height:250,
  },
  maintext:{
    paddingTop:0,
    paddingBottom:0,
  },
  chip: {
    margin: 4,
    backgroundColor:"rgb(240,240,240)"
  },
  wrapper: {
    display: 'flex',
    flexWrap: 'wrap',
  },
};

export default class ExperienceDailynibbler extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    };
  }

  handleExpandChange = (expanded) => {
    this.setState({expanded: expanded});
  };

  handleToggle = (event, toggle) => {
    this.setState({expanded: toggle});
  };

  handleExpand = () => {
    this.setState({expanded: true});
  };

  handleReduce = () => {
    this.setState({expanded: false});
  };

  render() {
    return (
      <Card
        expanded={this.state.expanded}
        onExpandChange={this.handleExpandChange}
        style={styles.card}
      >
        <CardHeader
          title="Dailynibbler LLC, Founder/Sole Developer"
          subtitle="Web App/Mobile App: 2015-2019"
          avatar="images/nibbler.jpg"
          actAsExpander={true}
          showExpandableButton={this.props.showCarrot}
          style={styles.cardheader}
        />
        <CardText
          style={styles.maintext}
        >
          <div>
            <ul>
              <li>
                Design and development of a full-stack website and mobile application platform
              </li>
              <div style={styles.wrapper}>
                <Chip style={styles.chip}>
                  React
                </Chip>
                <Chip style={styles.chip}>
                  NodeJS/Express
                </Chip>
                <Chip style={styles.chip}>
                  MongoDB
                </Chip>
                <Chip style={styles.chip}>
                  HTML/CSS/Javascript
                </Chip>
                <Chip style={styles.chip}>
                  jQuery
                </Chip>
                <Chip style={styles.chip}>
                  Cordova
                </Chip>
                <Chip style={styles.chip}>
                  PHP/MySQL
                </Chip>
                <Chip style={styles.chip}>
                  Google Maps API
                </Chip>
                <Chip style={styles.chip}>
                  Amazon AWS
                </Chip>
              </div>
            </ul>
          </div>
        </CardText>
        <CardMedia
          expandable={true}
          overlay={<CardTitle title="Dailynibbler" subtitle="" />}
        >
          <img
            src="images/dailynibbler_platform.jpg" alt=""
            style={styles.imgStyle}
          />
        </CardMedia>
        <CardText expandable={true}>
          <ul>
            <li>Dailynibbler is a website and mobile app that allows people to find and share local deals</li>
            <li>Current build using MongoDB/React/NodeJS</li>
            <li>First built using php/MySQL/jQuery</li>
            <li>Cross-platform programming (iOS and Android) using Cordova</li>
          </ul>
        </CardText>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ExperienceDailynibbler.js